import { ArrowDropDown } from "@material-ui/icons";
import { CircularProgress } from "@mui/material";
import { Select as AntdSelect, Spin } from "antd";
import { ALL_OPTION } from "constant";
import { memo, useMemo } from "react";

import classes from "./Select.module.css";

const Select = ({
  value,
  onChange,
  options,
  onSearch,
  isMulti,
  label,
  placeholder,
  error,
  loading,
  showAllOption,
  allowClear,
  onScroll,
  filterOption,
  readOnly,
  showSearch = true,
  excludes, // các giá trị bị loại bỏ khỏi list options
  labelInValue,
  onBlur,
}) => {
  const listOptions = useMemo(() => {
    let _listOptions = showAllOption
      ? [ALL_OPTION].concat(options || [])
      : options || [];

    if (excludes) {
      _listOptions = _listOptions.filter(
        (item) =>
          !excludes.find((excludeItem) =>
            labelInValue
              ? excludeItem.value === item.value
              : excludeItem === item.value
          )
      );
    }
    return _listOptions;
  }, [excludes, showAllOption, labelInValue, options]);

  return (
    <label
      className={classes.container}
      {...(readOnly && {
        style: { pointerEvents: "none" },
      })}>
      {!!label && (
        <span
          className={[classes.label, error && classes.labelError]
            .filter((item) => item)
            .join(" ")}>
          {label}
        </span>
      )}

      <AntdSelect
        showSearch={showSearch}
        {...(isMulti && { mode: "multiple" })}
        allowClear={
          value !== null || value !== "" || value === undefined
            ? allowClear
            : undefined
        }
        onClear={() => {
          onSearch?.("");
        }}
        optionFilterProp="children"
        className={[classes.select, error && classes.selectError]
          .filter((item) => item)
          .join(" ")}
        popupClassName={classes.popup}
        suffixIcon={<ArrowDropDown />}
        filterOption={
          filterOption === undefined
            ? (input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
            : filterOption
        }
        value={value}
        onChange={(newValue) => {
          if (!onChange) return;
          if (!isMulti) {
            // nếu có show all option, khi clear thì auto về tất cả
            if (
              showAllOption &&
              (newValue === null || newValue === undefined || newValue === "")
            ) {
              onChange(ALL_OPTION.value);
              return;
            }
            onChange(newValue || "");
            return;
          }

          // xử lý multiple value
          let multiValue = newValue;
          if (multiValue.indexOf(ALL_OPTION.value) > 0) {
            multiValue = [ALL_OPTION.value];
          } else if (
            multiValue.indexOf(ALL_OPTION.value) === 0 &&
            multiValue.length > 1
          ) {
            multiValue = newValue.filter((item) => item !== ALL_OPTION.value);
          } else if (showAllOption && newValue.length === 0) {
            multiValue = [ALL_OPTION.value];
          }
          onChange(multiValue);
        }}
        options={listOptions}
        dropdownRender={(menu) => (
          <Spin
            spinning={loading || false}
            indicator={<CircularProgress size={25} />}>
            {menu}
          </Spin>
        )}
        placeholder={placeholder}
        notFoundContent="Không có kết quả"
        onSearch={onSearch}
        onPopupScroll={onScroll}
        labelInValue={labelInValue}
        onBlur={onBlur}
      />
      {error && <p className={classes.error}>{error}</p>}
    </label>
  );
};

export default memo(Select);
